import {InputBase} from "@mui/material"
import {useEffect, useState} from "react"

import {CancelIconButton} from "../../../shared/component/button/IconButtons"
import {SxPropsMap} from "../../../shared/helper/HelperType"
import {Connection, Request, Type} from "../api/QueryType"
import {QueryBoxBody} from "./QueryBoxBody"
import {QueryButtonCreate} from "./QueryButtonCreate"
import {QueryInfoEdit} from "./QueryInfoEdit"
import {QueryTemplateWrapper} from "./QueryTemplateWrapper"

const SX: SxPropsMap = {
    input: {fontSize: "inherit", padding: "0"},
}

type Props = {
    type: Type,
    connection: Connection,
}

export function QueryTemplateNew(props: Props) {
    const {type, connection} = props
    const [body, setBody] = useState(false)
    const [queryCreate, setQueryCreate] = useState<Request>({name: "", query: "", type, plugin: connection.db.plugin})

    useEffect(handleEffectClose, [queryCreate.name, setBody])

    return (
        <QueryTemplateWrapper
            connection={connection}
            params={queryCreate.params}
            varieties={queryCreate.varieties}
            renderTitle={renderTitle()}
            renderButtons={renderButtons()}
            showButtons={queryCreate.name !== ""}
            showInfo={true}
            query={queryCreate.query}
        >
            <QueryBoxBody show={body}>
                <QueryInfoEdit query={{...queryCreate, type}} onChange={setQueryCreate}/>
            </QueryBoxBody>
        </QueryTemplateWrapper>
    )

    function renderTitle() {
        return (
            <InputBase
                sx={SX.input}
                fullWidth
                required
                placeholder={"Type new query name"}
                value={queryCreate.name}
                onChange={(e) => setQueryCreate({...queryCreate, name: e.target.value})}
            />
        )
    }

    function renderButtons() {
        return (
            <>
                {queryCreate.name !== "" && <CancelIconButton onClick={handleSuccess}/>}
                <QueryButtonCreate query={queryCreate} onSuccess={handleSuccess}/>
            </>
        )
    }

    function handleEffectClose() {
        if (queryCreate.name === "") setBody(false)
        else setBody(true)
    }

    function handleSuccess() {
        setQueryCreate({name: "", query: "", type, plugin: connection.db.plugin})
    }
}
